import { useMutation } from 'react-query';
import { useMicrositeApiContext } from 'contexts/MicrositeApiContext';
import { fetchSharedVisitJWT } from '@higo/api';

export const useExchangeSharingTokenForVisitJWTMutation = () => {
  const { baseAxios } = useMicrositeApiContext();

  return useMutation(fetchSharedVisitJWT(baseAxios));
};
